// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b743ab7c","977":"bcae8762"}[chunkId] + ".chunk.js";
};